import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Status from "./Status";
// JS Files
import MuiTextField from "../../shares/MuiTextField";
import useFetch from "../../../context/useFetch";
import MuiButton from "../../shares/MuiButton";
import noDataIcon from "../../../imgs/no-data.svg";

import { fixNumbers } from "../../../Utils";

// Others File

const SearchBox = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm();
  const [code, setCode] = useState();
  const [enterCaptchaValue, setEnterCaptchaValue] = useState("");
  const [captchaData, setCaptchaData] = useState({
    captcha_image: "",
    captcha_key: "",
  });
  const captchaApi = useFetch({
    method: "post",
    url: "api/captcha",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setCaptchaData(res);
      setEnterCaptchaValue("");
    },
    errMessage: (mess) => {
      toast.error("دوباره تلاش کنید ", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });

  const [data, setData] = useState(undefined);
  const getCaseStatus = useFetch({
    method: "POST",
    url: `TreatmentRequest_Service/check_case_treatment_status`,
    noHeader: true,
    trigger: false,
    data: {
      code: fixNumbers(code),
      captcha_value: enterCaptchaValue,
      captcha_key: captchaData.captcha_key,
    },
    argFunc: (res) => {
      if (res.data == "code_is_required") {
        toast.error("کد رهگیری را وارد نمایید", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else if (res.data == "code_not_found") {
        toast.error("کد رهگیری مورد نظر یافت نشد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        // props.setStatus(res.data);
        setData(res);
      captchaApi.reFetch();

      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
      captchaApi.reFetch();
    },
  });

  return (
    <>
      <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
        <div className="grid md:grid-cols-3 items-center ">
          <div className="border-r-4 col-span-3 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              کاربر گرامی جهت پیگیری پرونده خود کد رهگیری را وارد نمایید.
            </span>
          </div>
          <div className="mt-4 md:mt-0 col-span-3 md:col-span-1">
            <MuiTextField
              isLTR={true}
              id="code"
              label="کد رهگیری"
              variant="outlined"
              size="small"
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className=" flex justify-center col-span-3 md:col-span-1 mt-4 md:mt-0">
            <img
              className="w-36 h-24 md:w-48 md:h-24"
              src={`data:image/png;base64,${captchaData.captcha_image}`}
            />
          </div>

          <div className="col-span-3 md:col-span-1 mt-4 md:mt-0">
            <MuiTextField
              value={enterCaptchaValue}
              onChange={(e) => setEnterCaptchaValue(e.target.value)}
              id="outlined-basic"
              label="کد تصویری امنیتی"
              variant="outlined"
              size="small"
              name="captcha"
              isLTR
              type="captcha"
              control={control}
              register={{
                required: {
                  value: true,
                  message: "کد تصویری امنیتی را وارد کنید",
                },
              }}
            />
          </div>
          <div className="mt-4 md:mt-0 col-span-3 md:mr-12 text-center md:text-left">
            <MuiButton
              disabled={enterCaptchaValue === ""}
              onClick={() => {
                setData(undefined);
                getCaseStatus.reFetch();
              }}
              type="submit"
              variant="contained"
              color="primary"
              text="پیگیری"
            />
          </div>
        </div>
      </div>
      <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
        {data == undefined ? (
          <div className="flex justify-center items-center">
            <img src={noDataIcon} />
          </div>
        ) : (
          <Status status={data} />
        )}
      </div>
    </>
  );
};
export default SearchBox;
